(function() {
  if (window.TuopinColorSizePreserve) return;
  window.TuopinColorSizePreserve = true;

  var COLOR_LINK_SELECTOR = [
    'a[data-tuopin-product-swap]',
    '.sibling-color-swatches a[href*="/products/"]',
    '.color-swatch-list a[href*="/products/"]',
    '.variant-swatch-list a[href*="/products/"]'
  ].join(',');

  var REVIEW_BADGE_SELECTOR = [
    '.tuopin-mobile-product-rating',
    '.product-meta__reviews-badge',
    '.jdgm-preview-badge',
    '.jdgm-prev-badge'
  ].join(',');

  var REVIEW_TARGET_SELECTOR = [
    '#judgeme_product_reviews',
    '.jdgm-review-widget',
    '.jdgm-rev-widg',
    '.shopify-app-block .jdgm-widget:not(.jdgm-preview-badge):not(.jdgm-prev-badge)'
  ].join(',');

  var MOBILE_QUERY = '(max-width: 740px)';
  var lastSizeOptionChange = {
    time: 0,
    section: null,
    picker: null,
    formId: '',
    mediaId: ''
  };

  function normalizeSize(value) {
    return String(value || '').trim().toLowerCase().replace(/\s+/g, '');
  }

  function labelForInput(container, input) {
    if (!container || !input || !input.id) return null;
    var labels = container.querySelectorAll('label');
    for (var i = 0; i < labels.length; i++) {
      if (labels[i].htmlFor === input.id) return labels[i];
    }
    return null;
  }

  function findProductSection(element) {
    return element && element.closest ? element.closest('.shopify-section--main-product') || document.querySelector('.shopify-section--main-product') : document.querySelector('.shopify-section--main-product');
  }

  function currentSize(section) {
    if (!section) return '';

    var sizeControl = section.querySelector('.size-unit-select');
    var selector = sizeControl ? sizeControl.closest('.product-form__option-selector') : null;

    if (!selector) {
      section.querySelectorAll('.product-form__option-selector').forEach(function(candidate) {
        if (selector) return;
        var label = candidate.querySelector('.product-form__option-name');
        var text = label ? label.textContent.toLowerCase() : '';
        if (text.indexOf('size') !== -1 || text.indexOf('taille') !== -1 || text.indexOf('talla') !== -1) {
          selector = candidate;
        }
      });
    }

    if (!selector) return '';

    var checkedInput = selector.querySelector('input[type="radio"]:checked');
    var checkedLabel = labelForInput(selector, checkedInput);
    if (checkedLabel && checkedLabel.dataset.eu) return checkedLabel.dataset.eu;

    var selectedSwatch = selector.querySelector('.block-swatch__item.is-selected[data-eu]');
    if (selectedSwatch) return selectedSwatch.dataset.eu;

    var displayedValue = selector.querySelector('.product-form__option-value');
    return displayedValue ? displayedValue.textContent : '';
  }

  function normalizedOptionText(value) {
    var text = String(value || '').toLowerCase();
    if (text.normalize) {
      text = text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }
    return text;
  }

  function elementTarget(target) {
    if (!target) return null;
    return target.nodeType === 1 ? target : target.parentElement;
  }

  function isMobileViewport() {
    return window.matchMedia && window.matchMedia(MOBILE_QUERY).matches;
  }

  function controlFromOptionTarget(target) {
    if (!target || !target.closest) return null;
    if (target.matches && target.matches('input[data-option-position], select[data-option-position]')) return target;

    var label = target.closest('label[for]');
    if (label) {
      var input = document.getElementById(label.getAttribute('for'));
      if (input && input.matches && input.matches('input[data-option-position], select[data-option-position]')) return input;
    }

    var swatch = target.closest('.block-swatch__item, .color-swatch__item, .variant-swatch__item');
    if (swatch && swatch.getAttribute('for')) {
      var swatchInput = document.getElementById(swatch.getAttribute('for'));
      if (swatchInput && swatchInput.matches && swatchInput.matches('input[data-option-position], select[data-option-position]')) return swatchInput;
    }

    return null;
  }

  function isSizeOptionControl(element) {
    if (!element || !element.matches || !element.matches('input[data-option-position], select[data-option-position]')) return false;

    var selector = element.closest('.product-form__option-selector');
    if (!selector) return false;
    if (selector.querySelector('.size-unit-select')) return true;

    var label = selector.querySelector('.product-form__option-name');
    var text = normalizedOptionText(label ? label.textContent : '');
    return text.indexOf('size') !== -1 ||
      text.indexOf('taille') !== -1 ||
      text.indexOf('talla') !== -1 ||
      text.indexOf('grosse') !== -1 ||
      text.indexOf('groesse') !== -1;
  }

  function formIdForControl(control, picker) {
    if (!control) return picker && picker.getAttribute ? picker.getAttribute('form-id') || '' : '';
    if (control.getAttribute('form')) return control.getAttribute('form');
    if (control.form && control.form.id) return control.form.id;
    return picker && picker.getAttribute ? picker.getAttribute('form-id') || '' : '';
  }

  function mediaIdFromElement(element) {
    if (!element) return '';
    if (element.getAttribute && element.getAttribute('data-media-id')) return element.getAttribute('data-media-id');
    var mediaElement = element.querySelector && element.querySelector('[data-media-id]');
    return mediaElement ? mediaElement.getAttribute('data-media-id') : '';
  }

  function activeProductMediaId(section) {
    var productMedia = section && section.querySelector ? section.querySelector('product-media') : null;
    if (!productMedia) return '';

    var carousel = productMedia.mainCarousel;
    if (carousel && carousel.querySelector) {
      var carouselSelected = carousel.querySelector('[data-media-id].is-selected, .is-selected [data-media-id], [aria-hidden="false"][data-media-id], [aria-hidden="false"] [data-media-id]');
      var carouselSelectedId = mediaIdFromElement(carouselSelected);
      if (carouselSelectedId) return carouselSelectedId;
    }

    var selected = productMedia.querySelector('.product__media-item.is-selected[data-media-id], .product__media-item.is-selected [data-media-id], .product__media-item[aria-hidden="false"][data-media-id], .product__media-item[aria-hidden="false"] [data-media-id]');
    return mediaIdFromElement(selected);
  }

  function selectProductMedia(section, mediaId) {
    if (!section || !mediaId) return;

    var productMedia = section.querySelector('product-media');
    if (!productMedia) return;

    var selector = '[data-media-id="' + String(mediaId).replace(/"/g, '\\"') + '"]';
    var carousel = productMedia.mainCarousel;
    var target = carousel && carousel.querySelector ? carousel.querySelector(selector) : null;
    target = target || productMedia.querySelector(selector);
    if (!target) return;

    function selectFlickityCell(flickity) {
      if (!flickity || typeof flickity.select !== 'function') return false;

      var cells = typeof flickity.getCellElements === 'function' ? flickity.getCellElements() : [];
      for (var i = 0; i < cells.length; i++) {
        var cell = cells[i];
        if (cell === target || (cell.contains && cell.contains(target)) || (target.contains && target.contains(cell))) {
          flickity.select(i, false, true);
          return true;
        }
      }

      return false;
    }

    if (carousel && selectFlickityCell(carousel.flickity)) return;

    var instance = carousel && carousel.flickityInstance;
    if (instance && typeof instance.then === 'function') {
      instance.then(function(flickity) {
        if (!selectFlickityCell(flickity) && target.scrollIntoView) {
          target.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        }
      }).catch(function() {});
      return;
    }

    if (selectFlickityCell(instance)) return;

    if (target.scrollIntoView) {
      target.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }
  }

  function rememberSizeControl(control) {
    if (!isSizeOptionControl(control)) return;

    var picker = control.closest('variant-picker');
    var section = findProductSection(control);
    lastSizeOptionChange = {
      time: Date.now(),
      section: section,
      picker: picker,
      formId: formIdForControl(control, picker),
      mediaId: activeProductMediaId(section)
    };
  }

  function rememberSizeOptionIntent(event) {
    rememberSizeControl(controlFromOptionTarget(elementTarget(event.target)));
  }

  function formIdForEventTarget(target) {
    if (!target) return '';
    if (target.getAttribute) {
      if (target.getAttribute('form-id')) return target.getAttribute('form-id');
      if (target.getAttribute('form')) return target.getAttribute('form');
    }
    if (target.id && target.matches && target.matches('form')) return target.id;
    var picker = target.closest && target.closest('variant-picker');
    if (picker && picker.getAttribute('form-id')) return picker.getAttribute('form-id');
    var form = target.closest && target.closest('form');
    return form && form.id ? form.id : '';
  }

  function recentSizeChangeMatches(target) {
    if (Date.now() - lastSizeOptionChange.time > 1200) return false;
    if (!target) return document.querySelectorAll('.shopify-section--main-product').length === 1;

    var targetFormId = formIdForEventTarget(target);
    if (lastSizeOptionChange.formId && targetFormId && lastSizeOptionChange.formId === targetFormId) return true;

    var section = findProductSection(target);
    if (lastSizeOptionChange.section && section === lastSizeOptionChange.section) return true;

    var picker = target.closest && target.closest('variant-picker');
    if (lastSizeOptionChange.picker && picker === lastSizeOptionChange.picker) return true;

    return document.querySelectorAll('.shopify-section--main-product').length === 1;
  }

  function featuredMediaId(variant) {
    if (!variant) return '';
    if (variant.featured_media && variant.featured_media.id != null) return String(variant.featured_media.id);
    if (variant.featured_image && variant.featured_image.id != null) return String(variant.featured_image.id);
    return '';
  }

  function restoreMobileSizeMedia(event) {
    if (!isMobileViewport()) return;
    if (!recentSizeChangeMatches(elementTarget(event.target))) return;

    var detail = event.detail || {};
    var nextMediaId = featuredMediaId(detail.variant);
    var previousMediaId = featuredMediaId(detail.previousVariant);

    if (nextMediaId && previousMediaId && nextMediaId !== previousMediaId) return;
    if (!lastSizeOptionChange.mediaId) return;

    var section = lastSizeOptionChange.section || findProductSection(elementTarget(event.target));
    window.requestAnimationFrame(function() {
      selectProductMedia(section, lastSizeOptionChange.mediaId);
      window.setTimeout(function() {
        selectProductMedia(section, lastSizeOptionChange.mediaId);
      }, 160);
    });
  }

  document.addEventListener('pointerdown', rememberSizeOptionIntent, true);
  document.addEventListener('click', rememberSizeOptionIntent, true);
  document.addEventListener('change', rememberSizeOptionIntent, true);
  document.addEventListener('variant:change', restoreMobileSizeMedia, false);

  function productJsonUrl(url) {
    var productUrl = new URL(url, window.location.origin);
    productUrl.pathname = productUrl.pathname.replace(/\/products\/([^\/]+).*$/, '/products/$1.js');
    productUrl.search = '';
    productUrl.hash = '';
    return productUrl;
  }

  function sizeOptionIndex(product) {
    if (!product || !Array.isArray(product.options)) return -1;

    for (var i = 0; i < product.options.length; i++) {
      var option = product.options[i];
      var name = (typeof option === 'string' ? option : option && option.name) || '';
      name = name.toLowerCase();

      if (name.indexOf('size') !== -1 || name.indexOf('taille') !== -1 || name.indexOf('talla') !== -1) {
        return i;
      }
    }

    return -1;
  }

  function variantSize(variant, index) {
    if (!variant || index < 0) return '';
    if (Array.isArray(variant.options) && variant.options[index] != null) return variant.options[index];
    return variant['option' + (index + 1)] || '';
  }

  function withVariant(url, variantId) {
    var nextUrl = new URL(url, window.location.origin);
    nextUrl.searchParams.set('variant', variantId);
    nextUrl.searchParams.delete('section_id');
    nextUrl.searchParams.delete('_');
    return nextUrl.toString();
  }

  function urlWithMatchingSize(url, sizeValue) {
    var requestedSize = normalizeSize(sizeValue);
    if (!requestedSize) return Promise.resolve(url);

    return fetch(productJsonUrl(url).toString(), {
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then(function(response) {
      if (!response.ok) throw new Error('Product JSON failed');
      return response.json();
    }).then(function(product) {
      var index = sizeOptionIndex(product);
      var fallback = null;

      if (index < 0 || !Array.isArray(product.variants)) return url;

      for (var i = 0; i < product.variants.length; i++) {
        var variant = product.variants[i];
        if (normalizeSize(variantSize(variant, index)) !== requestedSize) continue;
        if (variant.available) return withVariant(url, variant.id);
        if (!fallback) fallback = variant;
      }

      return fallback ? withVariant(url, fallback.id) : url;
    });
  }

  function runnableScript(script) {
    var type = (script.getAttribute('type') || '').trim().toLowerCase();
    return type === '' || type === 'text/javascript' || type === 'application/javascript' || type === 'module';
  }

  function runInsertedScripts(container) {
    container.querySelectorAll('script').forEach(function(oldScript) {
      if (!runnableScript(oldScript)) return;

      var script = document.createElement('script');
      Array.prototype.slice.call(oldScript.attributes).forEach(function(attribute) {
        script.setAttribute(attribute.name, attribute.value);
      });
      script.text = oldScript.textContent || '';
      oldScript.replaceWith(script);
    });
  }

  function sectionId(section) {
    return section && section.id ? section.id.replace(/^shopify-section-/, '') : '';
  }

  function restoreScrollPosition(scrollY) {
    if (Number.isFinite(scrollY) && Math.abs(window.scrollY - scrollY) > 1) {
      window.scrollTo(0, scrollY);
    }
  }

  function waitForPrimaryProductImage(section) {
    var image = section.querySelector('.product__media-list img[loading="eager"], .product__media-list img');
    if (!image || (image.complete && image.naturalWidth > 0)) return Promise.resolve();

    return Promise.race([
      new Promise(function(resolve) {
        image.addEventListener('load', resolve, { once: true });
        image.addEventListener('error', resolve, { once: true });
      }),
      new Promise(function(resolve) {
        window.setTimeout(resolve, 1200);
      })
    ]);
  }

  var latestColorIntent = 0;
  var activeSwapController = null;

  function waitBeforeRetry(delay) {
    return new Promise(function(resolve) {
      window.setTimeout(resolve, delay);
    });
  }

  function fetchProductSection(requestUrl, controller, attempt) {
    var nextAttempt = attempt || 0;
    var retryUrl = new URL(requestUrl.toString());
    retryUrl.searchParams.set('_', (Date.now() + nextAttempt).toString());

    return fetch(retryUrl.toString(), {
      credentials: 'same-origin',
      signal: controller ? controller.signal : undefined,
      headers: {
        'Accept': 'text/html',
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then(function(response) {
      if (response.ok) return response.text();

      var retryable = response.status === 429 || response.status >= 500;
      if (retryable && nextAttempt < 2) {
        return waitBeforeRetry(250 * (nextAttempt + 1)).then(function() {
          return fetchProductSection(requestUrl, controller, nextAttempt + 1);
        });
      }

      throw new Error('Product section failed');
    });
  }

  function swapProduct(url, link, intentId) {
    if (intentId !== latestColorIntent) return;

    var section = findProductSection(link);
    var id = sectionId(section);

    if (!section || !id) {
      window.location.href = url;
      return;
    }

    var requestUrl = new URL(url, window.location.origin);
    requestUrl.searchParams.set('section_id', id);
    requestUrl.searchParams.set('_', Date.now().toString());

    if (activeSwapController) activeSwapController.abort();
    var controller = window.AbortController ? new AbortController() : null;
    activeSwapController = controller;

    var preservedScrollY = window.scrollY;
    var preservedSectionHeight = section.getBoundingClientRect().height;
    section.style.minHeight = preservedSectionHeight + 'px';
    section.classList.add('tuopin-product-swap-loading');
    link.classList.add('is-loading');

    fetchProductSection(requestUrl, controller, 0).then(function(html) {
      if (intentId !== latestColorIntent || !section.isConnected) return null;

      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      var parsedSection = doc.getElementById(section.id) || doc.querySelector('.shopify-section--main-product');
      if (!parsedSection) throw new Error('Matching product section not found');

      var nextHtml = parsedSection.innerHTML.trim();

      if (!nextHtml) throw new Error('Empty product section');

      section.innerHTML = nextHtml;
      runInsertedScripts(section);
      window.history.pushState({ tuopinProductSwap: true }, '', url);
      document.dispatchEvent(new CustomEvent('tuopin:product:swapped', {
        detail: { url: url, section: section, scrollY: preservedScrollY }
      }));

      restoreScrollPosition(preservedScrollY);
      return waitForPrimaryProductImage(section).then(function() {
        section.style.removeProperty('min-height');
        window.requestAnimationFrame(function() {
          restoreScrollPosition(preservedScrollY);
        });
      });
    }).catch(function(error) {
      if ((controller && controller.signal.aborted) || intentId !== latestColorIntent) return;
      section.style.removeProperty('min-height');
      section.classList.remove('tuopin-product-swap-loading');
      window.location.assign(url);
    }).finally(function() {
      if (intentId === latestColorIntent) {
        section.style.removeProperty('min-height');
        section.classList.remove('tuopin-product-swap-loading');
      }
      link.classList.remove('is-loading');
      if (activeSwapController === controller) activeSwapController = null;
    });
  }

  function visibleTarget(element) {
    if (!element) return false;
    return !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
  }

  function findReviewTarget() {
    var targets = document.querySelectorAll(REVIEW_TARGET_SELECTOR);
    for (var i = 0; i < targets.length; i++) {
      if (visibleTarget(targets[i])) return targets[i];
    }
    return targets[0] || null;
  }

  function openReviewContainer(target) {
    if (!target) return;

    var collapsible = target.closest('collapsible-content');
    if (collapsible && collapsible.open !== true) {
      collapsible.open = true;
    }

    var tabWrapper = target.closest('.product-tabs__tab-item-wrapper');
    if (tabWrapper && tabWrapper.id) {
      var tabButton = document.querySelector('[aria-controls="' + tabWrapper.id + '"]');
      if (tabButton && tabButton.getAttribute('aria-expanded') !== 'true') {
        tabButton.click();
      }
    }
  }

  function scrollToReviews() {
    var target = findReviewTarget();
    if (!target) return false;

    openReviewContainer(target);

    window.setTimeout(function() {
      var header = document.querySelector('.shopify-section--header, #shopify-section-header, sticky-header, .header');
      var headerHeight = header ? header.getBoundingClientRect().height : 0;
      var offset = Math.max(72, headerHeight + 18);
      var top = target.getBoundingClientRect().top + window.pageYOffset - offset;

      window.scrollTo({
        top: Math.max(0, top),
        behavior: 'smooth'
      });
    }, 80);

    return true;
  }

  document.addEventListener('click', function(event) {
    var reviewBadge = event.target.closest(REVIEW_BADGE_SELECTOR);
    if (reviewBadge && !reviewBadge.closest(REVIEW_TARGET_SELECTOR) && scrollToReviews()) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    var link = event.target.closest(COLOR_LINK_SELECTOR);
    if (!link) return;
    if (event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
    if (link.getAttribute('aria-current') === 'true' || link.classList.contains('is-selected') || link.classList.contains('is-active') || link.classList.contains('sibling-swatch--active')) return;

    var href = link.getAttribute('href');
    if (!href || href.indexOf('#') === 0) return;

    var targetUrl = new URL(href, window.location.origin);
    if (targetUrl.origin !== window.location.origin || targetUrl.pathname.indexOf('/products/') === -1) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    var intentId = ++latestColorIntent;
    link.classList.add('is-loading');
    var selectedSize = currentSize(findProductSection(link));
    urlWithMatchingSize(targetUrl.toString(), selectedSize).then(function(nextUrl) {
      if (intentId !== latestColorIntent) return;
      swapProduct(nextUrl, link, intentId);
    }).catch(function() {
      if (intentId !== latestColorIntent) return;
      swapProduct(targetUrl.toString(), link, intentId);
    });
  }, true);

  window.addEventListener('popstate', function() {
    window.location.reload();
  });

})();

(function() {
  'use strict';

  if (window.TuopinProductMediaCounter) {
    window.TuopinProductMediaCounter.refresh();
    return;
  }

  var COUNTER_SELECTOR = '[data-tuopin-media-counter]';
  var OBSERVER_PROPERTY = '__tuopinMediaCounterObserver';
  var syncScheduled = false;

  function isFiltered(item) {
    return item.classList.contains('is-filtered') || item.hidden;
  }

  function imageItems(productMedia) {
    return Array.prototype.filter.call(
      productMedia.querySelectorAll('.product__media-list .product__media-item[data-media-type="image"]'),
      function(item) {
        return !isFiltered(item);
      }
    );
  }

  function selectedMedia(productMedia) {
    var selected = productMedia.querySelector(
      '.product__media-list .product__media-item.is-selected:not(.is-filtered)'
    );

    if (selected) return selected;

    var activeControl = productMedia.querySelector(
      '.product__media-nav [data-media-id][aria-current="true"]:not(.is-filtered)'
    );
    if (!activeControl) return null;

    var mediaId = activeControl.getAttribute('data-media-id');
    if (!mediaId) return null;

    return productMedia.querySelector(
      '.product__media-list .product__media-item[data-media-id="' +
        String(mediaId).replace(/"/g, '\\"') +
        '"]:not(.is-filtered)'
    );
  }

  function syncCounter(counter) {
    var productMedia = counter.closest('product-media');
    if (!productMedia) return;

    var items = imageItems(productMedia);
    var selected = selectedMedia(productMedia);
    var currentIndex = selected ? items.indexOf(selected) : 0;
    var shouldHide = items.length <= 1 || currentIndex < 0;

    counter.hidden = shouldHide;
    if (shouldHide) return;

    var current = counter.querySelector('[data-tuopin-media-current]');
    var total = counter.querySelector('[data-tuopin-media-total]');

    if (current) current.textContent = String(currentIndex + 1);
    if (total) total.textContent = String(items.length);
  }

  function syncAll() {
    syncScheduled = false;
    document.querySelectorAll(COUNTER_SELECTOR).forEach(syncCounter);
  }

  function scheduleSync() {
    if (syncScheduled) return;
    syncScheduled = true;
    window.requestAnimationFrame(syncAll);
  }

  function observe(counter) {
    var productMedia = counter.closest('product-media');
    if (!productMedia || productMedia[OBSERVER_PROPERTY]) return;

    var observer = new MutationObserver(scheduleSync);
    observer.observe(productMedia, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'aria-current', 'hidden']
    });
    productMedia[OBSERVER_PROPERTY] = observer;
  }

  function refresh() {
    document.querySelectorAll(COUNTER_SELECTOR).forEach(function(counter) {
      observe(counter);
      syncCounter(counter);
    });
  }

  window.TuopinProductMediaCounter = {
    refresh: refresh
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh, { once: true });
  } else {
    refresh();
  }

  document.addEventListener('variant:change', scheduleSync);
  document.addEventListener('variant:changed', scheduleSync);
  document.addEventListener('tuopin:product:swapped', function() {
    window.requestAnimationFrame(refresh);
  });
  document.addEventListener('shopify:section:load', refresh);
})();

/* Tuopin CDN revision: 2026-08-20-stable-color-product-swap-v2 */


